import React, { useEffect, useState, Fragment } from "react";
import { Upload, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getServicesShow,
  logServiceRepairUpdate,
  requestDocument,
  updateService,
  postServiceRowGoods,
  postServiceRowSupplyings,
  removeServiceRowSupplyings,
  updateServiceRowGoods,
  removeServiceRowGoods,
} from "../../../../redux/Actions/Service/serviceAction";
import {
  Button1,
  MainBlock,
  MainBlockWithContext,
  MiniBlock,
  MiniBlockOrderRows,
} from "../../../common/Buttons";
import Spinner from "../../../common/Spinner";
import PreviewComment from "./ServiceCommentPreview";
import SubmitComment from "./ServiceCommentSubmit";
import ServiceRepairAddress from "./modal/ServiceRepairAddress";
import ServiceRepairSms from "./ServiceRepairSms";
import { Divs, UlElements } from "../../../common/StyledComponents";
import {
  first_element_array,
  getUrlExtension,
  phonenumberValid,
} from "../../../../helpers/Utils";
import ServiceRepairShipment from "./modal/ServiceRepairShipment";
import moment from "moment";
import DocumentItem from "../../../common/GlobalModals/Orders/editModal/AttachOrderDocument/DocumentItem";
import FormWithOneInput from "../../../common/FormWithOneInput";
import { toFixedNumber } from "../../../../helpers/Utils";
import { status_options } from "../../../../helpers/GlobalOptions";
import OrderRowAdd from "../../../common/GlobalModals/Orders/editModal/order_row/order_row_add";
import { getSuppliersOption } from "../../../../redux/Actions/supplierAction";
import OrderRowsComponent from "../../../common/GlobalModals/Orders/editModal/order_row/order_row";
import ServiceSupplier from "./ServiceSupplier";
import styled from "styled-components";
import StatusComponent from "../../../common/GlobalModals/Orders/StatusComponent";
import { get_presta_services_options } from "../../../../redux/Actions/prestaAction";
import ServiceChangeProduct from "./ServiceProductChange";
import ServiceDataEditInput from "../ServiceDataEditInput";
import { setParcelTerminalsOptions } from "../../../../redux/Actions/options_action";

const collapseBlockFetch = () => {
  const defaultStorage = { general: true };

  const getLocalStorage = JSON.parse(localStorage.getItem("serviceRepair"))
    ? JSON.parse(localStorage.getItem("serviceRepair"))
    : defaultStorage;

  return getLocalStorage;
};

function ServiceModalComponent({ id }) {
  const dispatch = useDispatch();
  const { serviceShow, loadingShow } = useSelector((state) => state.service);

  const [showBlock, setShowBlock] = useState(collapseBlockFetch());
  const [supplySupplierData, setSupplySupplierData] = useState([]);
  const [editRepairPrice, setEditRepairPrice] = useState({
    price: serviceShow.service.price,
    contoller: false,
    loading: false,
  });

  useEffect(() => {
    dispatch(getServicesShow(id));
    dispatch(logServiceRepairUpdate(id));
    dispatch(setParcelTerminalsOptions());


    Promise.all([getSuppliersOption(), get_presta_services_options()]).then(
      (response) => {
        let newArray = [];
        if (response[0].data) {
          response[0].data.data.forEach((item) => {
            const findIndex = newArray.findIndex(
              (find) => find.name == item.name
            );
            if (findIndex == -1) {
              return newArray.push({
                value: item.id,
                name: item.name,
                code: item.code,
                label: item.title || item.name,
                is_code: item.is_code,
              });
            }
          });
        }
        if (response[1]) {
          response[1].forEach((d) => {
            return newArray.push({
              value: "presta_" + d.id,
              name: d.service_center,
              code: null,
              label: d.service_center + " - " + d.category,
              is_code: null,
            });
          });
        }
        setSupplySupplierData(newArray);
      }
    );
  }, []);

  const handleChangeCollapse = (name) => {
    const showObj = {
      ...showBlock,
      [name]: !showBlock[name],
    };
    setShowBlock(showObj);
    localStorage.setItem("serviceRepair", JSON.stringify(showObj));
  };

  const onClickSavePrice = () => {
    setEditRepairPrice({ ...editRepairPrice, loading: true });
    dispatch(updateService({ price: editRepairPrice.price, id })).then(
      (res) => {
        setEditRepairPrice({
          ...editRepairPrice,
          loading: false,
          contoller: false,
        });
      }
    );
  };

  const openRepairPrice = () => {
    if (editRepairPrice.contoller) {
      setEditRepairPrice({ ...editRepairPrice, contoller: false });
    } else {
      setEditRepairPrice({
        ...editRepairPrice,
        price: toFixedNumber(serviceShow.service.price),
        contoller: true,
      });
    }
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () =>
      callback({ name: img.name, url: reader.result })
    );
    reader.readAsDataURL(img);
  }

  const onChange = (info) => {
    if (info.file.status === "done") {
      getBase64(
        info.file.originFileObj,
        (imgObj) => dispatch(requestDocument(id, imgObj.url, "custom"))
        // onChangeAttachments(name, "docs", [...items, imgObj])
      );
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed!`);
      // this.setState({
      //   excel_loading: false,
      // });
    }
  };

  const {
    service,
    address,
    service_documents,
    service_description,
    sms,
    active_log,
    repair_history,
    shipments,
  } = serviceShow;

  if (loadingShow) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        {service && (
          <MainBlockWithContext
            color={"#ffa800"}
            action={showBlock.general}
            text={"Client information"}
            onChange={() => handleChangeCollapse("general")}
          >
            {showBlock.general && (
              <>
                <div className="py-4">
                  <div className="col-6">
                    <ServiceRepairAddress
                      address={address}
                      orderId={service.id}
                    />
                  </div>
                  <div className="text-center mb-4">
                    <div
                      className="badge badge-warning badge-middle  badge-order-price cursor-pointer"
                      // onClick={() => openRepairPrice()}
                    >
                      <Fragment>
                        Repair price: {toFixedNumber(service.total_price)}{" "}
                        {"\u20AC"}
                      </Fragment>
                    </div>
                  </div>
                  {editRepairPrice.contoller && (
                    <FormWithOneInput
                      type="number"
                      value={editRepairPrice.price || 0}
                      loading={editRepairPrice.loading}
                      onChange={(e) =>
                        setEditRepairPrice({
                          ...editRepairPrice,
                          price: e.target.value,
                        })
                      }
                      onSave={() => onClickSavePrice()}
                      onClose={() => openRepairPrice()}
                    />
                  )}

                  <ServiceDataEditInput
                    label={"Service no"}
                    value_name="service_number"
                    id={service.id}
                    value={service.service_number || ""}
                  />
                </div>
                {/*  */}

                <MiniBlock
                  color={"#8fc8f8"}
                  action={showBlock.general_goods}
                  onChange={() => handleChangeCollapse("general_goods")}
                >
                  Goods
                </MiniBlock>
                {showBlock.general_goods && (
                  <div className="bg-silver">
                    <div className="col-12 py-3 mb-2">
                      <div className="table-responsive">
                        <table className="table table-sm mb-0">
                          {service.service_rows &&
                            service.service_rows
                              .filter((e) => e.manual === false)
                              .map((e) => ({
                                id: e.id,
                                quantity: e.item_quantity,
                                product_name: e.item_name,
                                unit_price_tax_incl: e.item_price,
                                product_reference: e.item_code,
                                serial_number: !e.manual
                                  ? service.serial_number
                                  : "",
                                manual: false,
                                service_row_changes: e.service_row_changes,
                                supplyings: e.supplyings.map((d) => {
                                  let obj = { ...d };
                                  if (!d.supplier) {
                                    if (d.presta_service) {
                                      obj = {
                                        ...obj,
                                        supplier: {
                                          name: `${d.presta_service.address} - ${d.presta_service.manufacturer}`,
                                        },
                                      };
                                    }
                                  }
                                  return obj;
                                }),
                                shipments_count: e.shipments_count,
                              }))
                              .map((item, index) => (
                                <OrderRowsComponent
                                  mode={"Servisas"}
                                  key={index}
                                  item={item}
                                  orderId={service.id}
                                  deleteSupply={(itemId, orderId) =>
                                    dispatch(
                                      removeServiceRowSupplyings(
                                        itemId,
                                        orderId,
                                        service.id
                                      )
                                    )
                                  }
                                  updateSerialNumber={() => {}}
                                  updateOrderRowGoods={(
                                    variables,
                                    orderId,
                                    itemId
                                  ) =>
                                    dispatch(
                                      updateServiceRowGoods(
                                        variables,
                                        orderId,
                                        itemId
                                      )
                                    )
                                  }
                                  deleteOrderRowGoods={(orderId, itemID) =>
                                    dispatch(
                                      removeServiceRowGoods(orderId, itemID)
                                    )
                                  }
                                />
                              ))}
                        </table>
                      </div>
                      <div className="my-3"></div>

                      {/* table */}
                      <div className="table-responsive">
                        <TableStyled className="table table-sm mb-0">
                          <thead>
                            <tr>
                              {service.buy_date && (
                                <th scope="col">Date of purchase</th>
                              )}
                              {service.certificate_date && (
                                <th scope="col">Date of certificate</th>
                              )}
                              {service.certificate_number && (
                                <th scope="col">Certificate number</th>
                              )}

                              {service.buy_document && (
                                <th scope="col">Purchased document</th>
                              )}

                              {service.invoice && <th scope="col">Invoice</th>}

                              {service.document_type && (
                                <th scope="col">Document type</th>
                              )}

                              {service.number && <th scope="col">No.</th>}

                              {service.service_type && (
                                <th scope="col">Service type</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {service.buy_date && (
                                <td>
                                  {moment(service.buy_date).format(
                                    "YYYY-MM-DD"
                                  )}
                                </td>
                              )}
                              {service.certificate_date && (
                                <td>
                                  {moment(service.certificate_date).format(
                                    "YYYY-MM-DD"
                                  )}
                                </td>
                              )}
                              {service.certificate_number && (
                                <td>{service.certificate_number}</td>
                              )}

                              {service.buy_document && (
                                <td>{service.buy_document}</td>
                              )}
                              {service.invoice && <td>{service.invoice}</td>}
                              {service.document_type && (
                                <td>
                                  {service.document_type == "invoice"
                                    ? "Invoice"
                                    : service.document_type == "cheque"
                                    ? "Cheque"
                                    : ""}
                                </td>
                              )}
                              {service.number && <td>{service.number}</td>}
                              {service.service_type && (
                                <td>{service.service_type}</td>
                              )}
                            </tr>
                          </tbody>
                        </TableStyled>
                      </div>
                      <div className="my-3"></div>
                      {/* Table end */}

                      {service_description && (
                        <UlElements>
                          {service_description.description && (
                            <li style={{ fontSize: "0.8rem" }}>
                              <span className="font-weight-bold">Breaks: </span>
                              {service_description.description}
                            </li>
                          )}
                          {service_description.item_description && (
                            <li style={{ fontSize: "0.8rem" }}>
                              <span className="font-weight-bold">
                                Product outside:{" "}
                              </span>
                              {service_description.item_description}
                            </li>
                          )}
                          {service_description.item_set && (
                            <li style={{ fontSize: "0.8rem" }}>
                              <span className="font-weight-bold">
                                Complete set:{" "}
                              </span>
                              {service_description.item_set}
                            </li>
                          )}
                          {service_description.refuses_to_repair && (
                            <li style={{ fontSize: "0.8rem" }}>
                              <span className="font-weight-bold">
                                Refuses to repair:{" "}
                              </span>
                              {service_description.refuses_to_repair}
                            </li>
                          )}
                        </UlElements>
                      )}
                    </div>
                  </div>
                )}

                <MiniBlockOrderRows
                  color={"#8fc8f8"}
                  action={showBlock.general_repair}
                  onChange={() => handleChangeCollapse("general_repair")}
                  goodsAddRow={showBlock.general_repair_add}
                  goodsAddRowClick={() =>
                    setShowBlock({
                      ...showBlock,
                      general_repair_add: !showBlock.general_repair_add,
                    })
                  }
                >
                  Repair
                </MiniBlockOrderRows>
                {showBlock.general_repair && (
                  <Divs>
                    <div className="bg-silver py-2">
                      <div className="col-12">
                        <div className="table-responsive">
                          <table className="table table-sm mb-0">
                            {service.service_rows &&
                              service.service_rows
                                .filter((e) => e.manual)
                                .map((e) => ({
                                  id: e.id,
                                  quantity: e.item_quantity,
                                  product_name: e.item_name,
                                  unit_price_tax_incl: e.item_price,
                                  product_reference: e.item_code,
                                  manual: true,
                                  supplyings: e.supplyings,
                                }))
                                .map((item, index) => (
                                  <OrderRowsComponent
                                    mode={"Servisas_Remontas"}
                                    key={index}
                                    item={item}
                                    orderId={service.id}
                                    deleteSupply={(itemId, orderId) =>
                                      dispatch(
                                        removeServiceRowSupplyings(
                                          itemId,
                                          orderId,
                                          service.id
                                        )
                                      )
                                    }
                                    updateSerialNumber={() => {}}
                                    updateOrderRowGoods={(
                                      variables,
                                      orderId,
                                      itemId
                                    ) =>
                                      dispatch(
                                        updateServiceRowGoods(
                                          variables,
                                          orderId,
                                          itemId
                                        )
                                      )
                                    }
                                    deleteOrderRowGoods={(orderId, itemID) =>
                                      dispatch(
                                        removeServiceRowGoods(orderId, itemID)
                                      )
                                    }
                                    store_url={service.order_shop?.url}
                                  />
                                ))}
                          </table>
                        </div>
                      </div>
                      {showBlock.general_repair_add && (
                        <div>
                          <OrderRowAdd
                            mode="Service"
                            orderId={service.id}
                            postOrderRowGoods={(body, orderId, rowGoods) =>
                              dispatch(
                                postServiceRowGoods(body, orderId, rowGoods)
                              )
                            }
                          />
                        </div>
                      )}
                    </div>
                  </Divs>
                )}

                <MiniBlock
                  color={"#8fc8f8"}
                  action={showBlock.general_supply}
                  onChange={() => handleChangeCollapse("general_supply")}
                >
                  Service
                </MiniBlock>
                {showBlock.general_supply && (
                  <div className="bg-silver">
                    <ServiceSupplier
                      supplyItem={
                        service.service_rows
                          ? service.service_rows
                              .filter((e) => !e.manual)
                              .map((e) => ({
                                value: e.id,
                                label: e.item_name,
                              }))
                          : []
                      }
                      supplySupplier={supplySupplierData}
                      orderId={service.id}
                      postOrderRow={(
                        resVariables,
                        orderId,
                        supplier_selected
                      ) =>
                        postServiceRowSupplyings(
                          resVariables,
                          orderId,
                          supplier_selected,
                          service.id
                        )
                      }
                    />
                  </div>
                )}
                <MiniBlock
                  color={"#8fc8f8"}
                  action={showBlock.general_change}
                  onChange={() => handleChangeCollapse("general_change")}
                >
                  Exchange
                </MiniBlock>
                {showBlock.general_change && (
                  <div className="bg-silver">
                    <ServiceChangeProduct
                      service_id={service.id}
                      service_row_id={
                        service.service_rows
                          ? first_element_array(
                              service.service_rows
                                .filter((e) => !e.manual)
                                .map((e) => e.id)
                            )
                          : null
                      }
                    />
                  </div>
                )}

                {/*  */}
                <MiniBlock
                  color={"#8fc8f8"}
                  action={showBlock.general_status}
                  onChange={() => handleChangeCollapse("general_status")}
                >
                  Status
                </MiniBlock>
                {showBlock.general_status && (
                  <Divs>
                    <StatusComponent
                      mode="Servisas"
                      orderId={service.id}
                      avalaibleStatus={status_options}
                      order_histories={active_log.map((e) => ({
                        datetime: e.created_at,
                        title: e.user,
                        body: e.body,
                      }))}
                    />
                  </Divs>
                )}
              </>
            )}
          </MainBlockWithContext>
        )}
        {service && service.service_comments && (
          <MainBlockWithContext
            color={"#008aff"}
            action={showBlock.comments}
            text={"Comments"}
            onChange={() => handleChangeCollapse("comments")}
          >
            <div className="mb-4 mt-2">
              <MiniBlock
                color={"#7ebff7"}
                action={showBlock.comments_ka}
                onChange={() => handleChangeCollapse("comments_ka")}
              >
                KA comments
              </MiniBlock>

              {showBlock.comments_ka && (
                <div className="col-12">
                  <div className="my-2"></div>
                  <SubmitComment identifier="comment_ka" service_id={id} />
                  <PreviewComment
                    comments={service.service_comments}
                    type="comment_ka"
                  />
                </div>
              )}
              <MiniBlock
                color={"#7ebff7"}
                action={showBlock.comments_lp}
                onChange={() => handleChangeCollapse("comments_lp")}
              >
                Logistic comments
              </MiniBlock>
              {showBlock.comments_lp && (
                <div className="col-12">
                  <div className="my-2"></div>
                  <SubmitComment
                    identifier="comment_logistic"
                    service_id={id}
                  />
                  <PreviewComment
                    comments={service.service_comments}
                    type="comment_logistic"
                  />
                </div>
              )}

              <MiniBlock
                color={"#7ebff7"}
                action={showBlock.comments_services}
                onChange={() => handleChangeCollapse("comments_services")}
              >
                Service comments
              </MiniBlock>
              {showBlock.comments_services && (
                <div className="col-12">
                  <div className="my-2"></div>
                  <SubmitComment
                    identifier="comment_service"
                    service_id={id}
                  />
                  <PreviewComment
                    comments={service.service_comments}
                    type="comment_service"
                  />
                </div>
              )}
            </div>
          </MainBlockWithContext>
        )}

        <MainBlockWithContext
          color={"#d07ffe"}
          action={showBlock.doc_upload}
          text={"Documents"}
          onChange={() => handleChangeCollapse("doc_upload")}
        >
          <div className="pb-3">
            {service_documents.filter(
              (f) => f.document_type == "goods_appearance"
            ).length > 0 && (
              <>
                <MiniBlock
                  color={"#dca7fb"}
                  action={showBlock.document_1}
                  onChange={() => handleChangeCollapse("document_1")}
                >
                  Product appearance
                </MiniBlock>

                {showBlock.document_1 && (
                  <>
                    <DocumentItem
                      documents={service_documents
                        .filter((f) => f.document_type == "goods_appearance")
                        .map((e) => ({
                          ...e,
                          asset: e.attachment,
                          title: "Custom",
                          format: getUrlExtension(e.attachment.url),
                        }))}
                      deleteOrderDocument={false}
                    />
                  </>
                )}
              </>
            )}

            {service_documents.filter((f) => f.document_type == "complaint")
              .length > 0 && (
              <>
                <MiniBlock
                  color={"#dca7fb"}
                  action={showBlock.document_2}
                  onChange={() => handleChangeCollapse("document_2")}
                >
                  Complaints
                </MiniBlock>

                {showBlock.document_2 && (
                  <div className="mb-2">
                    <DocumentItem
                      documents={service_documents
                        .filter((f) => f.document_type == "complaint")
                        .map((e) => ({
                          ...e,
                          asset: e.attachment,
                          title: "Custom",
                          format: getUrlExtension(e.attachment.url),
                        }))}
                      deleteOrderDocument={false}
                    />
                  </div>
                )}
              </>
            )}
            {service_documents.filter((f) => f.document_type == "defect_act")
              .length > 0 && (
              <>
                <MiniBlock
                  color={"#dca7fb"}
                  action={showBlock.document_3}
                  onChange={() => handleChangeCollapse("document_3")}
                >
                  Defect act
                </MiniBlock>
                {showBlock.document_3 && (
                  <div className="mb-2">
                    <DocumentItem
                      documents={service_documents
                        .filter((f) => f.document_type == "defect_act")
                        .map((e) => ({
                          ...e,
                          asset: e.attachment,
                          title: "Custom",
                          format: getUrlExtension(e.attachment.url),
                        }))}
                      deleteOrderDocument={false}
                    />
                  </div>
                )}
              </>
            )}

            {service_documents.filter((f) => f.document_type == "refuses_to_repair")
              .length > 0 && (
              <>
                <MiniBlock
                  color={"#dca7fb"}
                  action={showBlock.document_3}
                  onChange={() => handleChangeCollapse("document_3")}
                >
                  Refuses to repair
                </MiniBlock>
                {showBlock.document_3 && (
                  <div className="mb-2">
                    <DocumentItem
                      documents={service_documents
                        .filter((f) => f.document_type == "refuses_to_repair")
                        .map((e) => ({
                          ...e,
                          asset: e.attachment,
                          title: "Custom",
                          format: getUrlExtension(e.attachment.url),
                        }))}
                      deleteOrderDocument={false}
                    />
                  </div>
                )}
              </>
            )}

            <MiniBlock
              color={"#dca7fb"}
              action={showBlock.document_4}
              onChange={() => handleChangeCollapse("document_4")}
            >
              Other
            </MiniBlock>

            {showBlock.document_4 && (
              <>
                <div className="mb-2">
                  <DocumentItem
                    documents={service_documents
                      .filter((f) => f.document_type == "custom")
                      .map((e) => ({
                        ...e,
                        asset: e.attachment,
                        title: "Custom",
                        format: getUrlExtension(e.attachment.url),
                      }))}
                    deleteOrderDocument={false}
                  />

                  <div className="position-relative mt-5">
                    <Upload
                      showUploadList={false}
                      onChange={onChange}
                      customRequest={dummyRequest}
                    >
                      <Button1
                        style={{
                          position: "absolute",
                          top: "-16px",
                          left: "50%",
                          transform: "translate(-50%, 0px)",
                        }}
                        text={"Pridėti naują dokumentą"}
                        option={"plus"}
                      />
                      <hr />
                    </Upload>
                  </div>
                </div>
              </>
            )}
          </div>
        </MainBlockWithContext>
      </div>

      <div className="col-12 col-lg-6">
        <Divs>
          {!showBlock.shipping && (
            <MainBlock
              color={"#59aba0"}
              action={showBlock.shipping}
              onChange={() => handleChangeCollapse("shipping")}
            >
              Shipping
            </MainBlock>
          )}
          {showBlock.shipping && (
            <ServiceRepairShipment
              id={id}
              shipmentAddr={address || {}}
              service={service}
              shipments={shipments}
              onChangeCol={() => handleChangeCollapse("shipping")}
            />
          )}
        </Divs>

        <Divs>
          <MainBlockWithContext
            color={"#adcb35"}
            action={showBlock.sms_send}
            text={
              <span>
                Send SMS to number{" "}
                <span
                  className={
                    phonenumberValid(address.phone || "") ? "" : "text-danger"
                  }
                >
                  {address.phone || ""}
                </span>
              </span>
            }
            onChange={() => handleChangeCollapse("sms_send")}
          >
            {showBlock.sms_send && (
              <ServiceRepairSms
                id={id}
                sms={sms}
                phoneNumber={address.phone}
                country_id={address.country_id}
              />
            )}
          </MainBlockWithContext>
        </Divs>
        <Divs>
          <MainBlockWithContext
            color={"#428dcc"}
            action={showBlock.history}
            text="Other"
            onChange={() => handleChangeCollapse("history")}
          >
            {showBlock.history && (
              <Divs>
                <MiniBlock
                  color={"#629acb"}
                  action={showBlock.repair_history}
                  onChange={() => handleChangeCollapse("repair_history")}
                >
                  Repair history
                </MiniBlock>
                {showBlock.repair_history && (
                  <div className="px-3 pt-2">
                    {Object.entries(repair_history).map((e) => (
                      <div className="py-1">
                        <div className="py-1 text-center">
                          {e[1].length > 0 ? (
                            <span>
                              History <b>S/N {e[0]}</b>:{" "}
                            </span>
                          ) : (
                            <span>
                              <b>S/N {e[0]}</b> the story is empty.
                            </span>
                          )}
                        </div>
                        {e[1].length > 0 &&
                          e[1].map((i) => (
                            <UlElements className="border-bottom" key={i.text}>
                              <li>{i.date}</li>
                              <li>{i.text}</li>
                            </UlElements>
                          ))}
                      </div>
                    ))}
                  </div>
                )}
              </Divs>
            )}
          </MainBlockWithContext>
        </Divs>
      </div>
    </div>
  );
}

const TableStyled = styled.table`
  th {
    font-size: 0.8rem;
  }

  td {
    font-size: 0.8rem;
  }
`;

export default ServiceModalComponent;
